import { AxiosResponse } from 'axios'
import { client } from '../../../shared/services/client'
import {
  IAccountingPreviewRequest,
  IAccountingPreviewResponse,
} from '../models/CommissionReconciliationTypes'

/** Accounting client. Uses the shared axios client and service registry. */
class AccountingReconciliationService {
  /** Posts the filters, returns the matching rows plus the unfiltered total. */
  static getPreview = async (
    request: IAccountingPreviewRequest,
  ): Promise<IAccountingPreviewResponse> => {
    client.setBaseURLForService('accounting')
    const res: AxiosResponse<IAccountingPreviewResponse> = await client.post(
      '/api/Accounting/reconciliation/preview',
      request,
    )
    return res.data
  }
}

export default AccountingReconciliationService
